export const onChange = (event, setState, setErrors) => {
    const { name, value } = event.target
    setState(prevState => ({ ...prevState, [name]: value }))
    setErrors && setErrors(prevState => ({ ...prevState, [name]: undefined }))
}

export const formattedValue = (value) => Number(value).toLocaleString('en-US');

export function formatDate(inputDate) {
    if (inputDate) {
        const parts = inputDate.split("-");
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);

        // Create a Date object
        const dateObject = new Date(year, month - 1, day);

        // Format the date as "dd-MM-yyyy"
        const formattedDate = `${padZero(dateObject.getDate())}-${padZero(dateObject.getMonth() + 1)}-${dateObject.getFullYear()}`;

        return formattedDate;
    }
    // Parse the input date in "yyyy-MM-dd" format

}

// Function to pad a single digit number with a leading zero
function padZero(number) {
    return number < 10 ? `0${number}` : number;
}

export const formatNumber = (value) => {
    const numberFormatter = Intl.NumberFormat('tr-TR');
    return numberFormatter.format(value)
}

export const formatNumber4Digits = (value) => {
    return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(value);
}

export function getNewYearsEveDate() {
    var currentDate = new Date(); // Current date and time
    var year = currentDate.getFullYear(); // Get the current year
    var newYearsEveDate = new Date(year, 0, 1); // New Year's Eve date (Month is 11 for December)

    return newYearsEveDate.toISOString().split('T')[0];
}

export function getEndOfTheYearDate() {
    var simdikiTarih = new Date();

    // Bir sonraki yılın yılbaşı tarihini al
    var birSonrakiYil = simdikiTarih.getFullYear() + 1;
    var birSonrakiYilbasi = new Date(birSonrakiYil, 0, 1);

    // Tarihi istediğiniz formatta göstermek için örnek formatlama
    var gun = birSonrakiYilbasi.getDate();
    var ay = birSonrakiYilbasi.getMonth() + 1; // JavaScript'te aylar 0'dan başlar
    var yil = birSonrakiYilbasi.getFullYear();

    return birSonrakiYilbasi.toISOString().split('T')[0]
}

export function writeProductName(product) {
    let collectionName = product.collectionName;
    let color = product.color;
    let pattern = product.pattern;
    let weight = product.weight;
    let names = [collectionName, color?.code, pattern?.code, weight?.code];
    names = names.filter(n => n !== undefined)
    let nameString = names.join(" - ")
    return nameString;
}